import {App as AntdApp, Alert} from "antd";
import className from "classnames/bind";
import {Button, FontAwesomeIcon} from "~/components";
import {rtkErrorMessage} from "~/reduxs/api/apiSlice";
import {useGetGscAuthUrlMutation} from "~/reduxs/api/gscApiSlice";
import style from "../style/Gsc.module.scss";

const cn = className.bind(style);

/**
 * Panel bắt đầu kết nối OAuth. Lấy URL consent từ BE, lưu `state` vào sessionStorage
 * (để callback đối chiếu chống CSRF nhẹ) rồi chuyển hướng cả trang sang Google.
 */
function GscConnect({projectId, revoked = false, email}) {

	const {notification} = AntdApp.useApp();
	const [getAuthUrl, {isLoading}] = useGetGscAuthUrlMutation();

	const handleConnect = async () => {
		try {
			const res = await getAuthUrl(projectId).unwrap();
			if (!res?.url) throw new Error('Không lấy được URL kết nối');
			// Lưu state để callback verify; kèm projectId để callback route lại đúng dự án.
			sessionStorage.setItem('gsc_oauth_state', res.state || '');
			window.location.href = res.url;
		} catch (e) {
			notification.error({message: 'Lỗi', description: rtkErrorMessage(e, 'Không thể bắt đầu kết nối Google')});
		}
	};

	return (
		<div className={cn('connectPanel')}>
			<div className={cn('connectIcon')}>
				<FontAwesomeIcon icon="fa-brands fa-google" />
			</div>
			<div className={cn('connectTitle')}>
				{revoked ? 'Kết nối lại Google Search Console' : 'Kết nối Google Search Console'}
			</div>
			<div className={cn('connectDesc')}>
				Kết nối tài khoản Google sở hữu website để đồng bộ dữ liệu hiệu suất tìm kiếm thật
				(clicks, impressions, từ khoá, vị trí xếp hạng). Chúng tôi chỉ xin quyền <strong>chỉ đọc</strong>.
			</div>

			{revoked && (
				<Alert
					type="warning"
					showIcon
					style={{textAlign: 'left', marginBottom: 18}}
					message="Kết nối trước đã bị thu hồi hoặc hết hạn"
					description={email ? `Tài khoản: ${email}. Vui lòng cấp quyền lại để tiếp tục đồng bộ.` : 'Vui lòng cấp quyền lại để tiếp tục đồng bộ.'}
				/>
			)}

			<Button primary loading={isLoading} onClick={handleConnect}
				leftIcon={<FontAwesomeIcon icon="fa-brands fa-google" />}>
				{revoked ? 'Kết nối lại' : 'Kết nối tài khoản Google'}
			</Button>
		</div>
	);
}

export default GscConnect;
